import { composeCountryPack, type CountryPack } from '../juridical';
import { COUNTRY_CODES } from '../shared';
import { BE_CIVIL_MODULE } from './be-civil-module.fixture';
import { FIQH_CORE_SECTION_IDS, PROVISIONAL_FIQH_CORE } from './fiqh-core.fixture';

export const PROVISIONAL_BE_SECTION_IDS = FIQH_CORE_SECTION_IDS;

/** What a resident of Belgium is given: the fiqh core and the Belgian civil module. */
export const PROVISIONAL_BE_COUNTRY_PACK: CountryPack = composeCountryPack(
  PROVISIONAL_FIQH_CORE,
  COUNTRY_CODES.BE,
  BE_CIVIL_MODULE,
);

/**
 * What the imam reviews: the fiqh core alone. The civil notes are I-DINA's, read on the official
 * texts, and are not put to the scholar.
 */
export const PROVISIONAL_FIQH_REVIEW_PACK: CountryPack = composeCountryPack(
  PROVISIONAL_FIQH_CORE,
  COUNTRY_CODES.BE,
  null,
);

/** The content as the app embeds it today: the core, and Belgium's module. */
export const PROVISIONAL_EMBEDDED_CONTENT = Object.freeze({
  core: PROVISIONAL_FIQH_CORE,
  modules: Object.freeze({ BE: BE_CIVIL_MODULE }),
});
